import { useMutation } from '@tanstack/react-query'
import axios from 'axios'
import { checkForAuthorization } from '../utils'

export const AddInvestorView = () => {
  return useMutation(
    (payload) => {
      return axios({
        method: 'post',
        url: `${process.env.REACT_APP_BASE_URL}/investors/add-investor-view`,
        headers: {
          'Authorization': `Bearer ${checkForAuthorization()}`,
          'Content-Type': 'application/json'
        },
        data: payload
      })
    },
    {
      onError: (error) => {
        console.error('Failed to track investor view:', error)
      }
    }
  )
}
